import { ChangeDetectionStrategy, Component, Inject, Optional, inject } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { App } from '@df/core/app';
import { ImageModule } from '@df/module-image/image.module';
import { FindMediaByLabellPipe } from '@df/ui/common/find-media-by-label.pipe';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ModalLayoutRightComponent, NModalLayoutRight } from 'projects/app-default/src/app/ui/modal/modal-layout-right.component';
import { NProductViewLayout, Product } from '../../../product.decorator';
import { ProductViewDimensionsAndDetailsComponent } from '../../product-view-dimensions-and-details.component';
export const DIMENSIONS_MODAL_RIGHT_ID = 'dimensionsAndDetailsModalRight';
export interface IProductViewDimensionsAndDetailsModalRightContent {
    content: NProductViewLayout.IBlockDataContent;
    product: Product<IProductDataV3>;
}
@DfModal({
    id: DIMENSIONS_MODAL_RIGHT_ID,
    position: 'right',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName)
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@Component({
    selector: 'product-view-dimensions-and-details-modal-right',
    templateUrl: './product-view-dimensions-and-details-modal-right.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ProductViewDimensionsAndDetailsComponent,
        FindMediaByLabellPipe,
        TranslationModule,
        ModalLayoutRightComponent,
        ImageModule,
        FindMediaByLabellPipe
    ]
})
export class ProductViewDimensionsAndDetailsModalRightComponent {
    constructor(
        @Optional()
        private modalRef: ModalRef<ProductViewDimensionsAndDetailsModalRightComponent>,
        @Optional()
        @Inject(MODAL_DATA)
        public content: IProductViewDimensionsAndDetailsModalRightContent
    ) {}
    readonly app = inject(App);
    /**
     * Close notification
     */
    close() {
        this.modalRef.close();
    }
}
